<template>
    <div class="fondo">
        <v-container style="margin: 0 auto ; max-width: 65rem; width: 100%;">
            <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
                <div>
                    <v-card class="mb-4" style="color: #0F57AC;padding: 1rem !important;">
                        <div style="padding: 1rem;">
                            <h1>
                                CONTROL DE ENDOTOXINAS EN AGUAS PARA DIALISIS DE LOS CENTROS CONTRATADOS
                            </h1>
                        </div>
                    </v-card>
                    <el-form :model="encuestaForm" label-position="top" :rules="rules" ref="encuestaForm">
                        <v-card class="mb-4">
                            <h3 style="margin-bottom: 1rem;">INFORME DE MICROBIOLOGÍA</h3>
                            <v-row>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Método" :label-width="formLabelWidth" prop="metodo">
                                        <el-input v-model="encuestaForm.metodo" autocomplete="off" disabled></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Sensibilidad" :label-width="formLabelWidth" prop="sensibilidad">
                                        <el-input v-model="encuestaForm.sensibilidad" autocomplete="off" disabled></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Fecha de muestreo" :label-width="formLabelWidth"
                                        prop="fecha_muestreo">
                                        <el-date-picker style="width: 100%;" v-model="encuestaForm.fecha_muestreo" type="date"
                                        placeholder="Fecha de Muestreo"  :editable=false>
                                    </el-date-picker>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="IPRESS" :label-width="formLabelWidth" prop="nombres">
                                        <el-select v-model="encuestaForm.ipress" filterable placeholder="IPRESS" style="width: 100%;">
                                            <el-option v-for="item in arrayClinica" :key="item.value" :label="item.descripCas"
                                                :value="item.id_cas">
                                            </el-option>
                                        </el-select>

                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>SALIDA DE ÓSMOSIS</h3>
                            <v-row style="margin-top: 1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Resultados" :label-width="formLabelWidth"
                                        prop="osmosis_resultado">
                                        <el-input v-model="encuestaForm.osmosis_resultado" autocomplete="off"><template
                                                #append>Valor referencial: 0.25 UE/ml </template></el-input>AGUA TRATADA PURIFICADA
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>PUNTO DE SALA</h3>
                            <v-row style="margin-top: 1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Resultados" :label-width="formLabelWidth"
                                        prop="sala_resultado">
                                        <el-input v-model="encuestaForm.sala_resultado" autocomplete="off"><template
                                            #append>Valor referencial: 0.25 UE/ml</template></el-input>AGUA TRATADA PURIFICADA
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>RETORNO DE ANILLO DE CIRCULACIÓN</h3>
                            <v-row style="margin-top: 1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Resultados" :label-width="formLabelWidth"
                                        prop="anillo_resultado">
                                        <el-input v-model="encuestaForm.anillo_resultado" autocomplete="off"><template
                                                #append>Valor referencial: 0.25 UE/ml</template></el-input>AGUA TRATADA PURIFICADA
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                    </el-form>
                </div>
                <v-btn color="primary" type="submit">Enviar</v-btn>
            </v-form>
        </v-container>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export default {
    data() {
        return {
            arrayClinica: [],
            formLabelWidth: "15px",
            encuestaForm: {
                metodo: "Limulus Amebocyte Lysate (LAL) Semicuantitativo",
                ipress: null,
                sensibilidad: "0.25 EU/mL",
                /*version: "1",
                fecha: "12/12/2022",*/
                fecha_muestreo: null,
                osmosis_resultado: null,
                sala_resultado: null,
                anillo_resultado: null
            },
            selectedSection: 'Su salud',
            valid: false,
            formData: {},
            rules: {
                required: v => !!v || "Este campo es obligatorio",
            },
            opcionesTabla1: ["Ninguna", "Leve", "Moderada", "Severa", "Extrema o no puede hacerlo"],
            opciones: ["Derecha", "Izquierda", "No Aplica"],
            respuestas: Array(12).fill(""),
        };
    },
    created() {
        this.loadIpress();
    },
    methods: {
        loadIpress() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_ipress/", { "tipoCas": 2 }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayClinica = res.data;
                        })
                        .catch((res) => {
                            /* this.dialog = false; */
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        submitForm() {
            console.log("envio formulario ", this.encuestaForm);
        },
    },
};
</script>

<style scoped>
::v-deep .el-form-item__label {
    line-height: 0px !important;
}

.v-card {
    padding: 2rem;
    border-radius: 12px;
    background:
        linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 15%, rgb(255, 255, 255) 100%)
}

.fondo {
    background: url(https://cdn.forms.office.net/images/aio/wave-pattern-v1.svg) center top / cover no-repeat, linear-gradient(180deg, #0F57AC 0%, rgba(3, 98, 206, 0.935) 100%);
    background-attachment: fixed;
    /* Fija el fondo al hacer scroll */
}
</style>